import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { AuthService } from './auth.service';
import { catchError } from 'rxjs/operators';
import { MaintenanceService } from '@app/services/maintenance.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private maintenance: MaintenanceService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this.authService.getCurrentUser();
    const isApiUrl = request.url.startsWith(environment.apiUrl);
    const isOtpUrl =
      request.url.startsWith(`${environment.authUrl}/verify-otp`) ||
      request.url.startsWith(`${environment.authUrl}/resend-otp`);

    if (this.authService.otpToken && isOtpUrl) {
      request = request.clone({
        setHeaders: {
          'x-otptoken': this.authService.otpToken,
        },
      });
    }
    if (currentUser && currentUser.token && isApiUrl) {
      request = request.clone({
        setHeaders: {
          'X-UserToken': `${currentUser.token}`,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if ([0, 502, 503, 504].includes(error.status)) {
          this.maintenance.enable();
        }

        return throwError(() => error);
      }),
    );
  }
}
